import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { MoonLoader } from 'react-spinners'
import injectSheet from 'react-jss'

const styles = () => {
  return {
    loadingContainer: {
      top: 'calc(50% - 30px)',
      left: 'calc(50% - 30px)',
      position: 'fixed',
    },
  }
}

@injectSheet(styles)
class LoadingSpinner extends Component {
  render() {
    const { classes } = this.props
    return (
      <div className={classes.loadingContainer}>
        <MoonLoader />
      </div>
    )
  }
}

LoadingSpinner.propTypes = {
  classes: PropTypes.object,
}

export default LoadingSpinner
